import BoltIcon from "@mui/icons-material/Bolt";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { Typography } from "@mui/material";

export const FormatIcon = ({ format }: { format: string }) => {
  const sx = { fontSize: { xs: "2.75rem", sm: "4.25rem" }, color: "inherit" };
  switch (format) {
    case "bullet":
      return (
        <svg
          data-testid="format-icon-bullet"
          data-projectile="bullet"
          aria-hidden
          viewBox="0 0 64 64"
          style={{ width: "4.25rem", maxWidth: "100%", height: "4.25rem", fill: "currentColor" }}
        >
          <path d="M12 25h25c8 0 15 5 18 7-3 2-10 7-18 7H12z" />
          <path d="M7 23h6v18H7z" opacity=".62" />
        </svg>
      );
    case "blitz":
      return <BoltIcon data-testid="format-icon-blitz" sx={sx} />;
    case "rapid":
      return <ScheduleIcon sx={sx} />;
    case "daily":
      return <CalendarMonthIcon sx={sx} />;
    default:
      return (
        <Typography sx={{ color: "inherit", fontSize: { xs: "2.75rem", sm: "4.25rem" }, lineHeight: 1 }}>♟</Typography>
      );
  }
};
